/**
 * @file reportsService.js
 * @description Ops-team reports. Daily report = one IST day's run / not-run /
 *              moved / overtime breakdown (default: yesterday).
 */
import apiClient from './apiClient';

const reportsService = {
    /**
     * Daily operations report for one IST day.
     * @param {string} [date] YYYY-MM-DD (IST). Omit for yesterday.
     */
    async getDaily(date) {
        const qs = date ? `?date=${encodeURIComponent(date)}` : '';
        return apiClient.get(`/reports/daily${qs}`);
    },

    // ── Weekly data check (Operations → Log Sheets) ─────────────────────────
    /**
     * One week (Mon→Sun, IST) of every working-fleet machine's data, read the
     * way the invoice reads it, with the auto findings, the team's verdicts and
     * the week's sign-off.
     * @param {string} [week] any YYYY-MM-DD inside the week (defaults to the last complete week)
     * @param {boolean} [force] recompute instead of using the server's cached week
     */
    async getWeeklyCheck(week, force = false) {
        const q = [];
        if (week) q.push(`week=${encodeURIComponent(week)}`);
        if (force) q.push('force=1');
        return apiClient.get(`/reports/weekly-check${q.length ? `?${q.join('&')}` : ''}`);
    },
    /** Record a verdict (OK / ISSUE / FIXED) for one machine's week. */
    async reviewWeeklyMachine({ week_start, equipment_id, verdict, note }) {
        return apiClient.post('/reports/weekly-check/review', { week_start, equipment_id, verdict, note });
    },
    /** Take a verdict back. */
    async clearWeeklyReview(week_start, equipment_id) {
        return apiClient.delete(`/reports/weekly-check/review?week_start=${encodeURIComponent(week_start)}&equipment_id=${encodeURIComponent(equipment_id)}`);
    },
    /** Sign the whole week off. */
    async signOffWeek({ week_start, note }) {
        return apiClient.post('/reports/weekly-check/sign-off', { week_start, note });
    },
    /** Recent weeks' sign-offs. */
    async getWeeklySignOffHistory(limit = 12) {
        return apiClient.get(`/reports/weekly-check/history?limit=${limit}`);
    },
    /** Email one week's check to the signed-in user's own address → { ok, sent_to, week_start }. */
    async mailWeeklyCheck(week_start) {
        return apiClient.post('/reports/weekly-check/mail', { week_start });
    },
};

export default reportsService;
